module.exports = __webpack_public_path__ + "img/dsci0068.6175fafb.jpg";